import React from 'react'

const CommonBtn = ({text,classname,icon,iconPotion,onClick}) => {
  return (
    <button onClick={onClick} className={`px-7 py-4  capitalize  rounded-md relative flex items-center  ${classname}`}><p className={`${iconPotion===" "?"order-1":"order-2"}`}>{text}</p> <span className={iconPotion}>{icon}</span></button>
  )
}

export default CommonBtn
